import { HiOutlineDocumentText, HiOutlineTrash, HiOutlineX } from "react-icons/hi";

const SelectedPrescriptionsBar = ({ selectedCount, loading, onDelete, onMerge, onClear }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="animate-slide-up fixed bottom-6 left-1/2 z-40 -translate-x-1/2 transform">
      <div className="flex items-center gap-4 rounded-lg border border-gray-200 bg-white px-4 py-2 shadow-lg">
        <div className="text-sm text-gray-600">
          <span className="font-medium">{selectedCount}</span> prescription{selectedCount > 1 ? "s" : ""} sélectionnée
          {selectedCount > 1 ? "s" : ""}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onDelete}
            disabled={loading}
            className="flex items-center gap-1.5 rounded-md bg-red-500 px-3 py-1.5 text-sm text-white transition-colors duration-200 hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div> : <HiOutlineTrash className="h-4 w-4" />}
            <span>Supprimer</span>
          </button>
          {selectedCount >= 2 && (
            <button
              onClick={onMerge}
              disabled={loading}
              className="flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-sm text-white transition-colors duration-200 hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <HiOutlineDocumentText className="h-4 w-4" />
              <span>Fusionner</span>
            </button>
          )}
          <button
            onClick={onClear}
            disabled={loading}
            className="text-gray-400 transition-colors duration-200 hover:text-gray-600 disabled:opacity-50"
            title="Désélectionner tout"
          >
            <HiOutlineX className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectedPrescriptionsBar;
